import { format } from 'date-fns'
import React from 'react'
import { Link } from 'react-router-dom'
import { Avatar } from '../../components/avatar'
import { Status } from '../../components/cards/statusTag'
import { TableComponent } from '../../components/table'
import { ORDERSTATUS } from '../../constants'
import { formatCurrency } from '../../helpers'
import { type OrderResponse } from '../../redux-toolkits/orders/orders.type'
import { StatusTone } from '../../redux-toolkits/shared/shared.type'
interface Props {
  orders: OrderResponse[]
  currentPage?: number
  totalDataCount?: number
  pageLimit?: number
  onPageChange?: (page: number) => void
  loading?: boolean
  showCustomerName?: boolean
  name?: string
  showName?: boolean
}

const OrderTable: React.FC<Props> = ({
  orders,
  currentPage,
  totalDataCount,
  pageLimit,
  onPageChange,
  loading,
  showCustomerName = false,
  name = 'Orders',
  showName,
}): JSX.Element => {
  return (
    <div className="w-full overflow-x-scroll">
      <TableComponent
        name={name}
        showName={showName}
        headers={[
          'Harmonized Reference',
          'Amount',
          showCustomerName ? 'Customer' : undefined,
          'Date',
          'Status',
        ]}
        rows={orders.map((order) => {
          return {
            id: order.order._id,
            content: [
              <Link
                to={`/orders/${order.order.harmonizedReference}`}
                className="
                hover:text-black hover:underline
                transition-all duration-500 font-recoleta
                "
                key={`${order.order._id}-product-id`}
              >
                #{order.order.harmonizedReference}
              </Link>,
              `${formatCurrency(order.order.amount)}`,
              showCustomerName ? (
                <div
                  className="flex items-center space-x-3"
                  key={`${order.order._id}-customer`}
                >
                  <Avatar
                    name={`${order.order.personalInformation.firstName} ${order.order.personalInformation.lastName}`}
                    useRandomBgColor
                  />
                  <span className="capitalize">
                    {`${order.order.personalInformation.firstName} ${order.order.personalInformation.lastName}`}
                  </span>
                </div>
              ) : undefined,
              `${format(order.order.createdAt, 'dd/MM/yyyy h:mma')}`,
              <div
                key={`${order.order._id}-status`}
                className="flex items-center gap-2 overflow-visible"
              >
                <Status
                  text={order?.order?.status
                    ?.toLowerCase()
                    ?.toLowerCase()
                    ?.split('_')
                    ?.join(' ')}
                  type={
                    (ORDERSTATUS.find(
                      (status) =>
                        status.name.toLowerCase() ===
                        order.order.status.toLowerCase(),
                    )?.type ?? 'warn') as StatusTone
                  }
                />
              </div>,
            ],
          }
        })}
        isEmpty={[undefined, 0].includes(orders.length)}
        loading={loading}
        currentPage={currentPage}
        totalDataCount={totalDataCount}
        pageLimit={pageLimit}
        onPageChange={onPageChange}
      />
    </div>
  )
}

export default React.memo(OrderTable)
